export default {
  ja: {
    SiteName: 'FKモバイルオーダー',
    Language: {
      Ja: '日本語',
      En: 'English'
    },
    PageTitle: {
      Index: 'FKモバイルオーダー',
      StoreSelect: '店舗選択',
      StoreList: '店舗選択',
      ReceiveMethod: 'お受け取り方法選択',
      MenuCategory: 'カテゴリー選択',
      MenuList: 'メニュー選択',
      Coupon: 'クーポン選択',
      SetMenuList: 'セットメニュー選択',
      SetMenuDetail: 'サイドメニュー選択',
      Cart: 'ご注文内容確認',
      OrderFixing: 'ご注文内容確定',
      TableOrderSelect: 'お受け取り方法選択',
      TableOrderInput: 'テーブル番号入力',
      TableOrderConfirm: 'テーブル番号確認',
      PaymentMethod: 'お支払い方法選択',
      InputCreditCard: 'クレジットカード情報入力',
      ConfirmCreditCard: 'クレジットカード情報入力',
      CompletedCreditCard: 'クレジットカード情報入力',
      InputMFCard: 'マイファーストカード情報入力',
      CompletedMFCard: 'マイファーストカード情報入力',
      OrderProcessing: 'ご注文受付処理中',
      OrderFailed: 'ご注文受付処理中',
      OrderComplete: 'オーダー完了',
      OrderHistory: 'ご注文履歴',
      UserPolicy: '利用規約',
      ErrorPage: 'モバイルオーダーへようこそ'
    },
    Index: {
      Description: 'お店で並ぶことなく、ご注文！<br>店舗で商品をスマートにお受け取りいただけます。',
      NoticeDriveThrough: '※ ドライブスルーでのお受け取りはできません。',
      SelectLanguage: '言語を選択してください',
      SelectLanguageEn: 'Please select a language',
      OrderStart: 'ご注文を始める',
      Welocome: 'モバイルオーダーへようこそ'
    },
    ShopSearch: {
      AreaSearch: 'エリア検索',
      CannotMFC: '※こちらの店舗ではマイファーストカードでお支払いすることはできません',
      Heading: 'お受け取り店舗をお選びください',
      LastUse: '前回ご利用いただいた店舗',
      Note: '※店舗の営業時間とは異なります',
      NotFound: '選択した地域には店舗がございません。地域を変更してご確認ください。',
      NotReception: '現在注文を受け付けておりません',
      SelectAbove: '上記のエリアから選ぶ',
      SelectArea: 'エリアから選ぶ',
      SelectReceive: 'お受け取りになられる店舗を選択してください',
      StoreNotFound: 'お探しの範囲内に該当する店舗はみつかりませんでした',
      SurroundingStore: '周辺の店舗から選ぶ'
    },
    ReceiveMethod: {
      CanOrderMenu: '現在ご注文いただけるメニュー',
      ConfirmTable: 'こちらのテーブル番号でよろしいでしょうか。',
      FixedTable: '確定する',
      CorrectionTable: '修正する',
      Grand: 'Grand menu',
      InCounter: 'カウンターで受け取る（お店で食べる）',
      InStore: '店舗で食べる',
      InStore2: 'お店で食べる',
      InputTableNumber: 'テーブル番号をご入力ください',
      InTable: 'スタッフが席までお届けする（お店で食べる）',
      Morning: 'Morning menu',
      OffHouse: '対象時間外',
      Select: 'お受け取り方法をお選びください',
      SpecificationTable: '入力完了',
      TableNumber: 'テーブル番号',
      Takeout: 'テイクアウト'
    },
    StoreInfo: {
      LastOrder: 'ラストオーダー',
      Grand: 'グランド',
      Morning: 'モーニング',
      OpeningTime: '営業時間',
      Tel: 'TEL',
      ReceptionTime: 'モバイルオーダー受付時間'
    },
    SetMenuList: {
      heading: 'セットメニューをお選びください'
    },
    SetMenuDetail: {
      Modal: {
        Heading: '以下からお選びください'
      },
      PutCart: 'カートに入れる',
      Selected: '選択中の'
    },
    Cart: {
      Accept: '同意する',
      AddingSelect: '上記以外に商品を追加する',
      Change: 'お受け取り方法の変更',
      CouponExcluded: '※こちらの商品は10%OFFクーポンの対象商品ではございません。',
      DetailChange: '内容の変更',
      DeterminingOrder: 'ご注文を決定する',
      Discontinued: '現在販売して<br>おりません',
      EmailAttention: 'メールアドレスをご入力いただけない場合は出来上がり通知等お送りできませんので、お支払い完了後に発行されるご注文番号を必ずお控えください。<br>※ メール受信制限をされている方は、@wendys-firstkitchen.co.jpからのメール受信を許可してください。',
      EmailAttentionDialog: 'メールアドレスをご入力いただけない場合は出来上がり通知等お送りできませんので、お支払い完了後に発行されるご注文番号を必ずお控えください。\r\n※ メール受信制限をされている方は、@wendys-firstkitchen.co.jpからのメール受信を許可してください。',
      EmailAttentionDialogYes: 'はい',
      EmailAttentionDialogNo: 'いいえ',
      Heading: 'ご注文内容の確認',
      NotApplying: '※適用できる商品はございません。',
      OrderDetail: 'ご注文内容',
      PrivacyTerms: [
        '※注文完了通知・出来上がり通知をお送りいたしますのでメールアドレスのご入力をお願いいたします。',
        '※テーブルオーダーのお客様は、出来上がり通知メールは送付いたしません。',
        'ご入力前に【{privacyPolicy}】をお読みください。',
        'ご同意戴ける場合は、チェックボックスにチェックをお願いいたします。'
      ],
      PrivacyPolicy: '個人情報の取得・利用について',
      ReceiveMethod: 'お受け取り方法',
      ReceiveStore: 'お受け取り店舗',
      UseCoupon: 'クーポン利用'
    },
    MenuCategory: {
      SelectMenu: 'メニューをお選びください'
    },
    Coupon: {
      Attention: 'ご利用上の注意点',
      Common: '共通',
      ExpirationDate: '有効期限',
      FKLimited: 'First Kitchen 限定',
      Heading: 'クーポン',
      Nothing: '現在ご利用できるクーポンがございません',
      Use: 'クーポンを使う',
      WFKLimited: 'Wendy’s First Kitchen 限定'
    },
    Order: {
      Attention: {
        NotComplete: '※まだご注文処理は完了しておりません。'
      },
      Cancel: 'ご注文を取りやめる',
      CompleteHeading: 'ご注文処理が完了しました',
      Failed: '注文処理でエラーが発生しました。注文画面を表示して、店舗スタッフにお声がけください。',
      OrderNumber: 'ご注文番号',
      PaymentMethod: 'お支払い方法',
      ProcessingHeading: 'ご注文受付処理中',
      Readme: '現在注文処理を行っています。',
      ReadmeBody: '30秒程経過しても画面が遷移しない場合は「更新ボタン」をおしてください。',
      ReceiveInfo: 'お受け取り情報',
      ToStore: '支払い画面へ進む',
      PleaseWait: 'ただいまお作りしています。<br>モニターにご注文番号が表示されたら、お受け取りください。<br>お受け取りの際、ご注文番号をご提示ください。<br>※テーブルオーダーのお客様は、スタッフがテーブルまでお持ちいたします。',
      AfterReceiving: '商品をお受け取り頂きましたら、下記ボタンをタップしてください。モバイルオーダートップページへ戻ります。',
      ReservedNumber: '予約番号',
      PaymentNumber: '決済番号',
      PaymentDate: '決済日時',
      Received: '商品を受け取りました',
      ReceivedConfirmation: '商品をお受け取り済みであれば「はい」を、まだの場合は「いいえ」をお選びください。'
    },
    OrderHistory: {
      Head: '最新5件のご注文履歴',
      NoItem: 'ご注文履歴はございません',
      OrderDate: 'ご注文日時',
      OrderAmount: 'お支払い金額',
      ShopName: '店舗名',
      ShopAddress: '住所',
      ShowDetail: '▼注文内容確認',
      GoTop: 'トップへ戻る'
    },
    Payment: {
      AuPay: 'au PAY',
      Balance: 'カード残高',
      CanUse: '※以下のカード会社に対応しております。',
      Complete: 'お支払いが完了しました',
      ConfirmationBalance: '残高を確認',
      ConfirmationHeading: '内容をご確認ください',
      CreditCard: 'クレジットカード',
      CreditCardHeading: 'クレジットカード情報入力',
      CardNumber: 'カード番号',
      DPay: 'd払い',
      MFCNumber: 'カード番号',
      InputPoint: '利用するポイントを入力してください',
      Method: 'お支払い方法を選択',
      MFCHeading: 'マイファーストカード情報入力',
      MyFirstCard: 'マイファーストカード',
      OnlineCharge: 'オンラインチャージ',
      Pay: '決済確定・商品を作り始める',
      PayPay: 'PayPay',
      PayTotal: 'お支払い合計',
      Pin: 'Pinコード',
      Point: 'ポイント',
      RakutenPay: '楽天ペイ',
      SaveCard: 'ご利用のカード情報を登録しますか？\r\n「いいえ」を選択した場合は登録されているカード情報も消去されます。',
      Select: 'お支払い方法をお選びください。',
      SecureCode: 'セキュリティコード',
      UseDPay: 'd払いでお支払い',
      UseNew: '新しいクレジットカードを使用',
      UsePoint: 'ポイントを利用する',
      UseSaved: '登録されているクレジットカードを使用'
    },
    Dialog: {
      YesText: 'はい',
      NoText: 'いいえ',
      OkText: 'はい'
    },
    PayPayDialog: {
      Precaution1: '決済しただけでは',
      Precaution2: '注文は完了しません',
      Precaution3: '注文を完了するには、決済後に画面を閉じずに、',
      Precaution4: 'オーダー完了画面が表示されるまでお待ちください。',
      UnderstandPrecaution: '注意事項を理解し、決済サービスを開く'
    },
    UserPolicy: {
      Head: '利用規約',
      Agree: '同意して始める'
    },
    General: {
      Cart: 'カート',
      Close: '閉じる',
      Change: '変更',
      Coupon: 'クーポン',
      Delete: '削除',
      Digits6: '(6桁)',
      Digits16: '(16桁)',
      Fix: '入力内容の確定',
      Limit: '有効期限',
      Minus: 'マイナス',
      Month: '月',
      Next: '次へ',
      NoHandling: 'お取り扱いしておりません',
      OrderHistory: 'ご注文履歴',
      Plus: 'プラス',
      Quantity: '数量',
      Previous: '前へ',
      PrivacyPolicy: 'プライバシーポリシー',
      Tokusho: '特定商取引法に基づく表記',
      Reload: '更新',
      Return: '戻る',
      Select: '選択',
      Send: '送信',
      Set: 'セット',
      Single: '単品',
      Tax: {
        Exclude: '税別',
        Include: '税込',
        None: '非課税'
      },
      Top: 'トップ',
      Total: '合計',
      Year: '年',
      Yen: '円'
    },
    AreaName: {
      kanto: '関東',
      kansai: '関西',
      shinetsu: '信越',
      chubu: '中部',
      kyushu: '九州'
    },
    PrefectureName: {
      tokyo: '東京',
      kanagawa: '神奈川',
      saitama: '埼玉',
      chiba: '千葉',
      gunma: '群馬',
      ibaraki: '茨城'
    },
    UserLogin: {
      AuthCode: '認証コード',
      AuthCodeDescription: '認証コードをご登録のメールアドレスに送信致しました。<br>メールに書かれた認証コードをご入力ください。',
      Description: 'ログインいただくと、前回ご利用の店舗、お支払い方法の連動など、より便利にお使いいただけます。ログインはこちらから。',
      Heading: 'アプリをお使いの方へ',
      MailAddress: 'メールアドレス',
      Password: 'パスワード',
      Signin: 'ログイン'
    },
    Maintenance: {
      Message: '現在、メンテナンス中のためモバイルオーダーをご利用いただけません。\nご迷惑をおかけして申し訳ございませんが、店舗にてご注文をお願い致します。\n(Mobile order is unavailable because it is currently under maintenance.\nPlease place your order directly at the store.\nWe apologize for any inconveniences caused.)',
      ButtonText: 'はい(OK)'
    },
    ErrorPage: {
      Title: 'エラーが発生いたしました',
      PleaseWait: 'しばらくしてからもう一度お試しください。',
      ErrorCode: 'エラーコード:'
    },
    ErrorMsg: {
      ERR_001: 'お使いのブラウザでは位置情報が利用できません。ブラウザを変えてお試しください。',
      ERR_002: '位置情報の利用が許可されていません。位置情報の機能をONにしてください。',
      ERR_003: '位置情報の取得に失敗しました。ＧＰＳの電波が届かない場所にいるか、位置情報の機能がoffになっていないかご確認ください。',
      ERR_004: 'タイムアウトしました。',
      ERR_011: '注文受付時間を過ぎたため、受付は終了しております。',
      ERR_012: '本日のモバイルオーダー受付時間は終了いたしました。',
      ERR_013: '選択された商品は注文受付の対応時間外です。',
      ERR_021: '商品が選択されていません。カートに商品を追加してください。',
      ERR_023: 'パラメータが不正です。申し訳ございませんが、もう一度はじめからやり直して下さい。',
      ERR_031: 'エリアを選択してください。',
      ERR_101: 'トークンの取得に失敗しました。',
      ERR_201: '楽天ペイは、100円以上のお支払からご利用になれます。',
      ERR_701: 'dアカウントの認証に失敗しました。',
      ERR_702: 'dアカウントの認証に失敗しました（想定外の端末）: ',
      ERR_703: 'dアカウントの認証に失敗しました（遷移元確認エラー）',
      ERR_901: 'タイムアウトしました。',
      ERR_902: '通信エラーが発生しました。',
      ERR_911: 'オブジェクトの要素数が超過しました。',
      ERR_999: 'アプリケーションエラーが発生しました。時間をおいてお試しいただくか、お問い合わせフォームからご連絡ください。'
    },
    InvalidMsg: {
      ERR_001: 'メールアドレスを入力してください。',
      ERR_002: 'メールアドレスは254文字以内で入力してください。',
      ERR_011: 'クレジットカード番号を入力してください。',
      ERR_012: 'クレジットカードは16桁の数字で入力してください。',
      ERR_021: '有効期限（月）を選択してください。',
      ERR_022: '有効期限（月）の有効な値を選択してください。',
      ERR_031: '有効期限（年）を選択してください。',
      ERR_032: '有効期限（年）の有効な値を選択してください。',
      ERR_041: 'セキュリティコードを入力してください。',
      ERR_042: 'セキュリティコードは3～4桁の数字で入力してください。',
      ERR_051: 'マイファーストカード番号を入力してください。',
      ERR_052: 'マイファーストカード番号は16桁の数字で入力してください。',
      ERR_061: 'PINコードを入力してください。',
      ERR_062: 'PINコードは6桁の数字で入力してください。',
      ERR_071: '利用ポイント数は数字で入力してください。',
      ERR_072: '利用ポイント数は0～',
      ERR_073: 'の範囲で入力してください。',
      ERR_074: '当社独自のサービス（１０％OFF等）をご利用時は、ポイントでのお支払いはできません。',
      ERR_081: '個数を入力してください。',
      ERR_082: '個数は1から99の数字で入力してください。',
      ERR_091: 'パスワードを入力してください。',
      ERR_101: 'テーブル番号を入力してください。',
      ERR_102: 'テーブル番号は3桁の数字で入力してください。',
      ERR_111: '認証コードを入力してください。'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/lang/TranslationsJA.js